import React, { useState } from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import Scanner from '../../components/Scanner/Index';
import { Button, Card, Col, message, Row } from 'antd';
import Item from '../../components/Detail/Item';
import Date from '../../components/Formatter/Date';
import axios from '../../util/Api';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

const Index = () => {
  const [loading, setLoading] = useState(false);
  const [passport, setPassport] = useState(null);
  const [tapLoading, setTapLoading] = useState(false);

  const handleScan = (data) => {
    fetchProfileData(data);
  }

  const fetchProfileData = (number) => {
    setLoading(true);
    const url = `/scan/passport`;
    axios.get(url, { params: { number: number } }).then(resp => {
      if (resp.data.success) {
        setPassport(resp.data.passport);
        setLoading(false);
      } else {
        setPassport(null);
        message.error('Data personel tidak ditemukan');
        setLoading(false);
      }
    }).catch(err => {
      
    });
  }

  const handlePresence = (type) => {
    setTapLoading(true);
    const url = `tap/store`;
    const data = {
      project: passport.project.project.id,
      passport: passport.id,
      type: type,
    };
    axios.post(url, data).then(resp => {
      message.success("Data berhasil disimpan");
      setTapLoading(false);
      setPassport(null);
    }).catch(err => {
      message.error("Gagal menyimpan data");
      setTapLoading(false);
    });
  }

  const Rescan = () => {
    return (
      <Button onClick={() => {
        setPassport(null);
      }}>Ulangi Scan Data</Button>
    );
  }

  const isPresenceAllowed = () => {
    return passport.project.approval && passport.project.status.is_active && passport.project.induction_status;
  }

  const DisabledActions = () => {
    return (
      <Row>
        <Col span={12}>
          <Button type="primary" size="large" block disabled>Masuk</Button>
        </Col>
        <Col span={12}>
          <Button type="default" size="large" block danger disabled>Keluar</Button>
        </Col>
      </Row>
    );
  }

  const EnabledActions = () => {
    return (
      <Row>
        <Col span={12}>
          <Button type="primary" size="large" block onClick={() => handlePresence(1)} loading={tapLoading}>Masuk</Button>
        </Col>
        <Col span={12}>
          <Button type="default" size="large" block danger onClick={()=>handlePresence(2)} loading={tapLoading}>Keluar</Button>
        </Col>
      </Row>
    );
  }

  const Actions = () => {
    return (
      <div className="gx-text-center">
        <Rescan />
      </div>
    );
  }

  const AllowedPresence = () => {
    return (
      <div className="gx-mb-4">
        <div className="gx-text-center gx-mb-4">
          <h2 className="ant-typography ant-typography-success"><CheckCircleOutlined /> Boleh Masuk</h2>
        </div>
        <EnabledActions />
      </div>
    );
  }

  const DisallowedPresence = () => {
    return (
      <div className="gx-mb-4">
        <div className="gx-text-center gx-mb-4">
          <h2 className="ant-typography ant-typography-danger"><StopOutlined /> Tidak Boleh Masuk</h2>
        </div>
        <DisabledActions />
      </div>
    );
  }

  const Profile = () => {
    return (
      <div className="gx-mb-2" style={{ border: "1px solid #ebebeb", padding: "20px", borderRadius: "5px" }}>
        {isPresenceAllowed() ? <AllowedPresence /> : <DisallowedPresence />}

        <Item label="Nomor ID" value={passport.number}/>
        <Item label="Nama" value={passport.name}/>
        <Item label="Divisi Operasi" value={passport.project.division.label}/>
        <Item label="Proyek" value={passport.project.project.name}/>
        <Item label="HSE Level" value={passport.project.level ? `${passport.project.level.label}${passport.project.quality}` : `-`}/>
        <Item label="Status" value={passport.project.status.label} />
        <Item label="Hasil Induksi" value={passport.project.induction_status ? `Passed` : `Not Passed`}/>
        <Item label="Tanggal Masuk" value={<Date value={passport.project.start_date} />} />
        <Item label="Tanggal Expired" value={<Date value={passport.project.end_date} />} />
        <Item label="Perusahaan" value={passport.vendor.name}/>
        <Item label="Status Pelanggaran" value={passport.violation ? passport.violation.level.label : "Tidak ada pelanggaran"} />
      </div>
    );
  }

  return (
    <Auxiliary>
      <Title>Absensi Personel</Title>
      <Card className="gx-card">
        {passport ? <Actions /> : <div className="gx-text-center"><Scanner onScan={handleScan} /></div>}
        {loading ? <div className="gx-text-center">Sedang memuat...</div> : passport ? <Profile passport={passport} /> : null}
      </Card>
    </Auxiliary>
  );
}

export default Index;